import { MatrixReferential } from '../schema/Matrix/MatrixReferential';

export const MatrixReferentialFixture = MatrixReferential.parse({
  matrixKinds: [
    {
      code: 'A00GY',
      label: 'Aulx et échalotes',
      deprecated: false,
      matrices: ['A00GZ', 'A00HF']
    },
    {
      code: 'A00QT',
      label: 'Radis et similaires',
      deprecated: false,
      matrices: ['A00QV', 'A00QX', 'A00QY', 'A0DNK', 'A0DNJ', 'A00QZ']
    },
    {
      code: 'A001M',
      label: 'Blé (froment)',
      deprecated: false,
      matrices: ['A001P', 'A001R', 'A00DL', 'A001N', 'A001M']
    },
    {
      code: 'A00RT',
      label: 'Asperges',
      deprecated: false,
      matrices: ['A00RT']
    },
    {
      code: 'A00TQ',
      label: 'Champignons de couche',
      deprecated: false,
      matrices: ['A00TQ']
    },
    {
      code: 'A01GP',
      label: 'Prunes et similaires',
      deprecated: false,
      matrices: [
        'A01GQ',
        'A01HA',
        'A0DVJ',
        'A01GT',
        'A01GV',
        'A01JM',
        'A01GR',
        'A01GX',
        'A01GY',
        'A0DVH',
        'A01GS',
        'A0DVG',
        'A01GZ'
      ]
    },
    {
      code: 'A01QX',
      label: 'Viande bovine',
      deprecated: false,
      matrices: ['A01QV#F28.A0C0S', 'A01XF#F28.A0C0S']
    },
    {
      code: 'A01SN',
      label: 'Viande de volaille',
      deprecated: false,
      matrices: [
        'A01SP#F28.A0C0S',
        'A01SP#F31.A0CSD',
        'A01SQ#F28.A0C0S',
        'A01SN#F26.A07XE'
      ]
    },
    {
      code: 'A0D9Y',
      label: 'Orge et similaires',
      deprecated: true,
      matrices: ['A0D9Y']
    },
    {
      code: 'A0DEH',
      label: 'Poireaux et similaires',
      deprecated: false,
      matrices: ['A00SB', 'A00HM']
    },
    {
      code: 'A0DQS',
      label: 'Pitaya / fruits du Dragon',
      deprecated: false,
      matrices: ['A0DQS']
    },
    {
      code: 'A0DVX',
      label: 'Abricots et similaires',
      deprecated: false,
      matrices: ['A01GF']
    }
  ],
  matrices: [
    {
      code: 'A001M',
      label: 'Blé (froment)',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A001N',
      label: 'Froment',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A001P',
      label: 'Blé dur',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A001R',
      label: 'Epeautre',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00DL',
      label: 'Triticale',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00GZ',
      label: 'Aulx',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00HF',
      label: 'Échalotes',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00HM',
      label: 'Kurrat',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00QV',
      label: 'Radis',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00QX',
      label: 'Radis noir',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00QY',
      label: 'Daïkon',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00QZ',
      label: 'Souchets comestibles/Amandes de terre',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00RT',
      label: 'Asperges',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00SB',
      label: 'Poireaux',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A00TQ',
      label: 'Champignons de couche',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GF',
      label: 'Abricots',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GQ',
      label: 'Prunes',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GR',
      label: 'Prunes de Damas/Quetsches',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GS',
      label: 'Mirabelles',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GT',
      label: 'Prunes-cerises ',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GV',
      label: 'Prunes Chickasaw ',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GX',
      label: 'Reines-claudes',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GY',
      label: 'Prunes du Japon',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01GZ',
      label: 'Prunelles',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01HA',
      label: "Prunes d'Amérique",
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01JM',
      label: 'Jujubes communs',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01QV#F28.A0C0S',
      label: 'Viande de bovin non transformée',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A01SN#F26.A07XE',
      label: "Viande d'autres volailles non transformée",
      deprecated: false,
      sachaSigle: 'MSCL_VOL'
    },
    {
      code: 'A01SP#F28.A0C0S',
      label: 'Viande de poulets de chair non transformée',
      deprecated: false,
      sachaSigle: 'VDE_FRA_POUL'
    },
    {
      code: 'A01SP#F31.A0CSD',
      label: 'Viande de poule de réforme non transformée',
      deprecated: false,
      sachaSigle: 'MSCL_VOL'
    },
    {
      code: 'A01SQ#F28.A0C0S',
      label: 'Viande de dinde non transformée',
      deprecated: false,
      sachaSigle: 'VDE_FRA_DIND'
    },
    {
      code: 'A01XF#F28.A0C0S',
      label: 'Foie de bovin non transformé',
      deprecated: false,
      sachaSigle: 'FOIE_BV'
    },
    {
      code: 'A0D9Y',
      label: 'Orge et similaires',
      deprecated: true,
      sachaSigle: null
    },
    {
      code: 'A0DNJ',
      label: 'Petits radis ',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A0DNK',
      label: 'Racines de maca',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A0DQS',
      label: 'Pitaya / fruits du Dragon',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A0DVG',
      label: 'Plumcots',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A0DVH',
      label: 'Prunes Klamath',
      deprecated: false,
      sachaSigle: null
    },
    {
      code: 'A0DVJ',
      label: 'Prunes maritimes',
      deprecated: false,
      sachaSigle: null
    }
  ]
});
